import { LinkByNumberPicker } from '~/components/invoices/detailPage/related/LinkByNumberPicker';
import { LinkedInvoicesTable } from '~/components/invoices/detailPage/related/LinkedInvoicesTable';
import { useRelatedInvoiceLinking } from '~/components/invoices/useRelatedInvoiceLinking';
import type { Invoice } from '~/data/schemas/invoice';

/**
 * The invoices and proposals linked to this one, linkable and unlinkable here.
 *
 * Everything else billed against the elevators this invoice serviced is a view
 * on the Cars Serviced tab, with the elevators themselves.
 */
export function InvoicesSection({ invoice }: { invoice: Invoice }) {
  const { invoiceOptions, onAddRelatedInvoice, onRemoveRelatedInvoice } =
    useRelatedInvoiceLinking(invoice);

  // Inside the table, above its Columns/Filters row — same reasoning as the
  // ticket picker.
  const picker = (
    <LinkByNumberPicker
      options={invoiceOptions}
      inputLabel="Invoice/proposal Number"
      noOptionsText="No options"
      onLink={onAddRelatedInvoice}
    />
  );

  return (
    <LinkedInvoicesTable
      relatedInvoices={invoice.relatedInvoices}
      onUnlink={onRemoveRelatedInvoice}
      headerContent={picker}
    />
  );
}
